/**
 * Messages that Extension sends to the Platform
 * @readonly
 * @enum {string}
 */
export const INCOMING_MESSAGE = {
  displayGenerationForm: 'displayGenerationForm',
  displayInsightsPanel: 'displayInsightsPanel',
  displaySuggestionsPanel: 'displaySuggestionsPanel',
  windowFocused: 'windowFocused',
  platformInfoCheck: 'platformInfoCheck',
  logout: 'logout',
  trackEvent: 'trackEvent',
  scoreText: 'scoreText',
  brandVoiceSettings: 'brandVoiceSettings',
};

/**
 * Messages that Platform sends to the Extension
 * @readonly
 * @enum {string}
 */
export const OUTGOING_MESSAGE = {
  platformReady: 'platformReady',
  platformInfo: 'platformInfo',
  frameViewReady: 'frameViewReady',
  closeFrame: 'closeFrame',
  displayFullscreen: 'displayFullscreen',
  submitInstructions: 'submitInstructions',
  scoreTextResult: 'scoreTextResult',
  displaySuggestionInsights: 'displaySuggestionInsights',
  applySuggestion: 'applySuggestion',
  brandVoiceSettings: 'brandVoiceSettings',
  brandVoiceContent: 'brandVoiceContent',
};

export const ERROR_CODE = {
  quotaEnded: 'quota_ended',
};
